import './App.css';
import SniperForm from './components/SniperForm';
import FirstTimeUser from './components/FirstTimeUser';
import Contact from './components/Contact'
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import About from "./components/About";
import FAQ from "./components/Faq";

function App() {
    return (
        <Router>
            <Switch>
                <Route exact path="/snipe" component={SniperForm} />
            </Switch>
            <Switch>
                <Route exact path="/about" component={About} />
            </Switch>
            <Switch>
                <Route exact path="/faq" component={FAQ} />
            </Switch>
            <Switch>
                <Route exact path={'/contact'} component={Contact}/>
            </Switch>
            <Switch>
                <Route exact path={'/'} component={FirstTimeUser}/>
            </Switch>
        </Router>
    );
}

export default App;
